







































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { MediaResource } from '@/interfaces/Models';

@Component
export default class Documents extends Vue {

    @Prop({ type: String,  required: true })
    public documentKey!: string;

    @Prop({ type: String, required: true })
    public path!: string;

    @Prop({ required: true })
    public resource!: MediaResource;

    @Prop({ required: true })
    public types!: string[];

    public mediaResource: MediaResource = {
        id: 0,
        src: '',
        srcSet: '',
        thumb: '',
        lazy: '',
        mime_type: '',
    }

    public acceptedTypes: any = {
        image: 'image/*',
        pdf: '.pdf'
    }

    public deletionDialog: boolean = false;

    public get accept() {
        let data: string[] = [];

        this.types.forEach((value: string) => {
            if ( value in this.acceptedTypes ) {
                data.push(this.acceptedTypes[value]);
            }
        });

        return data.join(',');
    }

    public get isPDF() {
        return this.mediaResource.mime_type == 'application/pdf';
    }

    public get mediaIsSet(): boolean {
        if ( this.mediaResource.id > 0 ) {
            return true;
        }
        return false;
    }

    public preview() {
        if ( this.mediaIsSet ) {
            window.open(this.mediaResource.src);
        }
    }

    public deleteMedia() {
        if (this.mediaIsSet) {

            this.uploading = true;
            this.deletionDialog = false;
            
            let params = {
                media: this.documentKey
            };

            axios.delete(this.path.split(this.documentKey.replace(/_/gi, '-'))[0], { params: params })
            .then(res => { 
                this.mediaResource = { 
                    id: 0,
                    src: '',
                    srcSet: '',
                    thumb: '',
                    lazy: '',
                    mime_type: '',
                }
                this.$toast.success(res.data.message);
            })
            .finally(() => this.uploading = false );
        }
    }

    @Watch('resource')
    onResourceChange(media: MediaResource) {
        
        if ( media ) {
            this.mediaResource = { ...media };
        }
    }

    public uploading: boolean = false;
    
    public upload(/* document: File */e: Event) {
        let target = e.target as HTMLInputElement;

        let document: File = (target.files as FileList)[0];

        if ( !document ) {
            return;
        }

        this.uploading = true;

        let formData = new FormData();

        formData.append(this.documentKey, document);
        
        axios.post(this.path, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(res => { 
            this.mediaResource = { 
                id: res.data.data.id,
                src: res.data.data.src,
                srcSet: res.data.data.srcSet,
                thumb: res.data.data.src,
                lazy: res.data.data.lazy,
                mime_type: res.data.data.mime_type,
            }
            this.$toast.success('Successful upload');
        })
        .finally(() => this.uploading = false );

    }
    
}
